import { render, staticRenderFns } from "./houseCreate.vue?vue&type=template&id=13a13a46&scoped=true&"
import script from "./houseCreate.vue?vue&type=script&lang=js&"
export * from "./houseCreate.vue?vue&type=script&lang=js&"
import style0 from "./houseCreate.vue?vue&type=style&index=0&id=13a13a46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a13a46",
  null
  
)

export default component.exports